import type { TAction } from '../../models';

export const start: TAction = ({ form }) => {
    const { change } = form;

    change('authenticationStatus', 'processing');
    change('authenticationStep', 'enterPhoneNumber');
};
